import {useAuth} from '../../auth/useAuth';
import {canReturnCrmSearchContext} from './crmSearchContext';

/** A detail close may return only to a search opened by this authenticated principal. */
export function useCrmSearchReturn(){
  const {user,authEpoch}=useAuth();
  const principal=`${user?.id}:${user?.role}:${JSON.stringify(user?.simulation??null)}:${authEpoch}`;
  return ()=>{
    if(!canReturnCrmSearchContext(principal,window.location.pathname+window.location.search))return false;
    window.history.back();return true;
  };
}
